// combine reducers here
import auth from "./auth";
import uploads from "./uploads";
import { reducer as form } from "redux-form";

export default {
  auth,
  uploads,
  form
};



// WEBPACK FOOTER //
// ./src/ducks/index.js